import React from 'react';
import { motion } from 'framer-motion';
import { 
  Zap, ShieldAlert, Cpu, 
  BarChart3, Globe2, Video, 
  Users2, LayoutDashboard 
} from 'lucide-react';
import styles from './FeaturePowerhouse.module.css';

const FeaturePowerhouse = () => {
  const brandOrange = "#e87355";
  const brandBlue = "#5ba5e0";

  const features = [
    {
      icon: <Cpu size={32} color={brandOrange} />,
      title: "Hyper-realistic AI Anchors",
      desc: "State-of-the-art neural avatars with human-like expressions and perfect lip-sync."
    },
    {
      icon: <Video size={32} color={brandBlue} />,
      title: "Daily Video Production",
      desc: "Fresh, relevant news content delivered to your dashboard every single day."
    },
    {
      icon: <LayoutDashboard size={32} color={brandOrange} />,
      title: "Professional Visuals",
      desc: "Virtual studios and high-end news graphics that rival national TV networks."
    },
    {
      icon: <Zap size={32} color={brandBlue} />,
      title: "Fast Delivery",
      desc: "Go from script to broadcast-ready video in minutes, not hours."
    },
    {
      icon: <Users2 size={32} color={brandOrange} />,
      title: "Zero Dependency",
      desc: "No more waiting for anchors or editors. Your channel runs 24/7 on autopilot."
    }
  ];

  return (
    <section className={styles.container}>
      {/* 1. THE POWERHOUSE HEADER */}
      <div className={styles.header}>
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className={styles.topContent}
        >
          <h2 className={styles.mainTitle}>
            Turn Your Channel Into a <br />
            <span className={styles.gradientText}>24x7 Digital News Powerhouse</span>
          </h2>
          <p className={styles.subLead}>
            No studio. No anchor salary. No production headache. <br />
            <span>Ready to publish on YouTube, Facebook, and beyond.</span>
          </p>
        </motion.div>
      </div>

      {/* 2. THE "WHAT WE DO" VISION BLOCK */}
      <div className={styles.visionBlock}>
        <div className={styles.visionBadge}>
          <Globe2 size={16} /> WHAT WE DO
        </div>
        <h3>We don’t just create videos. <span>We build fully automated digital news channels.</span></h3>
      </div>

      {/* 3. INTERACTIVE FEATURE GRID */}
      <div className={styles.featureGrid}>
        {features.map((item, idx) => (
          <motion.div 
            key={idx}
            className={styles.glassCard}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            whileHover={{ y: -10 }}
            viewport={{ once: true }}
            transition={{ delay: idx * 0.1 }}
          >
            <div className={styles.iconCircle}>{item.icon}</div>
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
            <div className={styles.cardGlow} />
          </motion.div>
        ))}

        {/* PROMO CARD */}
        <motion.div 
          className={`${styles.glassCard} ${styles.promoCard}`}
          whileHover={{ scale: 1.02 }}
        >
          <div className={styles.promoContent}>
             <ShieldAlert color={brandOrange} size={40} />
             <h4>Start Your Empire</h4>
             <p>Take the leap into the future of digital journalism.</p>
             <button className={styles.cardBtn}>Get Started <Zap size={16} fill="white" /></button>
          </div>
        </motion.div>
      </div>

      {/* BACKGROUND DECOR */}
      <div className={styles.bgGlow} />
    </section>
  );
};

export default FeaturePowerhouse;